import { BreakpointObserver } from '@angular/cdk/layout';
import { Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ItemToSell, ItemsToSellService } from 'src/app/_services';
import { MaterialPage } from 'src/app/components/page/material-page.component';
import { environment } from 'src/environments/environment';
import { SidenavService } from 'src/app/_services/sidenav.service';

@Component({
  templateUrl: './seller-listing-chat-page.component.html',
  styleUrls: ['./seller-listing-chat-page.component.scss']
})
export class SellerListingChatPageComponent extends MaterialPage {
  
  item: ItemToSell | undefined;
  chatId: number | undefined;
  picturesUrl = environment.picturesUrl;
  
  constructor(
    private route: ActivatedRoute,
    readonly router: Router,
    breakpointObserver: BreakpointObserver,
    private itemsToSellService: ItemsToSellService,
    meta: Meta,
    sidenavService: SidenavService,
    titleService: Title) {
      
    super(breakpointObserver, titleService, meta, sidenavService, router, $localize `:page title:Listing conversations`, '', true);
  }
  
  async ngOnInit() {
    
    const routeParams = this.route.snapshot.paramMap;
    const chatIdFromRoute = Number(routeParams.get('chatId'));
    const itemIdFromRoute = Number(routeParams.get('itemId'));

    this.chatId = chatIdFromRoute;
    
    this.item = (await this.itemsToSellService.find(itemIdFromRoute))!;
  }
}
